"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SocialShareIcon = require("./SocialShareIcon");
Object.keys(_SocialShareIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SocialShareIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SocialShareIcon[key];
    }
  });
});
